import Link from '../Link';
import Image from '../Image';

const mock = {
	image: Image.Mock,
	link: Link.Mock,
};

export default mock;
